const loadBundles = () => {
  document.addEventListener("DOMContentLoaded", () => {
    /* Accordion */
    const accordions = document.querySelectorAll(
      '[data-behaviour="accordion"]'
    );

    if (accordions.length > 0) {
      import("@/components/accordion").then(({ render }) => {
        accordions.forEach((accordion) => {
          render(accordion);
        });
      });
    }

    /* Carousel */
    const carousel = document.querySelectorAll('[data-behaviour="carousel"]');

    if (carousel.length > 0) {
      import("@/components/carousel").then(({ render }) => {
        carousel.forEach((carouselEl) => {
          render(carouselEl);
        });
      });
    }

    /* Marquee */
    const marquees = document.querySelectorAll('[data-behaviour="marquee"]');

    if (marquees.length > 0) {
      import("@/components/marquee").then(({ initMarquees }) => {
        initMarquees();
      });
    }

    const reviewsMarquees = document.querySelectorAll(
      '[data-behaviour="reviews-marquee"]',
    );

    if (reviewsMarquees.length > 0) {
      import("@/components/reviews-marquee").then(({ render }) => {
        reviewsMarquees.forEach((el) => {
          render(el);
        });
      });
    }

    /* WooCommerce Loading States */
    // Check if we're on a WooCommerce page
    const isWooCommercePage = document.body.classList.contains('woocommerce') || 
                             document.body.classList.contains('woocommerce-page') ||
                             document.body.classList.contains('single-product') ||
                             document.body.classList.contains('archive-product') ||
                             document.body.classList.contains('cart') ||
                             document.body.classList.contains('checkout') ||
                             document.body.classList.contains('my-account');

    if (isWooCommercePage) {
      import("@/components/woocommerce/loading").then(({ render }) => {
        render();
      });
    }

    const shopArchiveFilters = document.querySelector(".shop-archive-filters");

    if (shopArchiveFilters) {
      import("@/components/woocommerce/shop-archive-filters").then(({ render }) => {
        render(shopArchiveFilters);
      });
    }

    /* WooCommerce Menu Cart */
    // Check if WooCommerce is active and we have cart elements
    const hasWooCommerceCart = document.querySelector('.woocommerce-menu-cart-count, .woocommerce-menu-cart-count-mobile');
    
    if (hasWooCommerceCart && typeof wc_cart_fragments_params !== 'undefined') {
      import("@/components/woocommerce/menu-cart").then(({ render }) => {
        render();
      });
    }

    /* Video Overlay */
    const videoOverlays = document.querySelectorAll('.video-overlay');

    if (videoOverlays.length > 0) {
      import("@/components/video-overlay").then(({ render }) => {
        videoOverlays.forEach((overlay) => {
          render(overlay);
        });
      });
    }

    /* Core Video Autoplay */
    const coreAutoplayVideos = document.querySelectorAll('.wp-block-video video[autoplay]');

    if (coreAutoplayVideos.length > 0) {
      import("@/components/core-video-autoplay").then(({ render }) => {
        coreAutoplayVideos.forEach((videoEl) => {
          render(videoEl);
        });
      });
    }

    const secondaryBanners = document.querySelectorAll(
      '[data-behaviour="secondary-banner"]'
    );

    if (secondaryBanners.length > 0) {
      import("@/components/secondary-banner").then(({ render }) => {
        secondaryBanners.forEach((bannerEl) => {
          render(bannerEl);
        });
      });
    }
  });
};

export default loadBundles;
